import moment from "moment";
import AdminBadge from "../_components/AdminBadge";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { ViewLink } from "../_components/AdminRowActions";

const BOOKING_STATUS_TONES = {
  CONFIRMED: "success",
  PAYMENT_PENDING: "info",
  READY_TO_CHECKOUT: "info",
  INQUIRY: "warning",
  CANCELLED: "danger",
  CANCELED: "danger",
};

const PAYMENT_STATUS_TONES = {
  CHARGED: "success",
  PAID: "success",
  CHARGE_PENDING: "warning",
  WAITING_FOR_PAYMENT: "warning",
  CHARGE_FAILED: "danger",
  INCOMPLETED: "danger",
};

// The abandoned-cart rows carry raw enums; render them the way the booking list does.
const humanize = (value) =>
  value
    ? value
        .toLowerCase()
        .split("_")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    : "-";

const getRoleText = (role, deferredPaymentEligible) => {
  if (role === "individual") return { role: "B2C", detail: "Member" };
  if (role === "business") {
    return deferredPaymentEligible ? { role: "B2B", detail: "Deferred" } : { role: "B2B", detail: "Advance" };
  }
  return { role: "B2C", detail: "Guest" };
};

const getBookingTypeLabel = (bookingType, isAirportTransfer) => {
  if (bookingType === "byTheHour") return "By The Hour";
  if (isAirportTransfer) return "Airport Transfer";
  return "Specified Destination";
};

const DateTimeCell = ({ value }) => {
  const date = moment(value).locale("en");
  return (
    <div className="tw:flex tw:flex-col">
      <span className="tw:whitespace-nowrap">
        {date.format("YYYY/MM/DD")} <span className="tw:!text-[13px] tw:!text-[#8D8D8D]">{date.format("(ddd)")}</span>
      </span>
      <span>{date.format("H:mm")}</span>
    </div>
  );
};

const BookingItem = ({
  bookings: {
    _id,
    bookingStatus,
    picuplocation,
    pickupLocation,
    pickupDateTime,
    date,
    customer,
    bookingType,
    isAirportTransfer,
    paymentStatus,
    dataVersion = "v1",
    referral,
  },
  count,
}) => {
  const roleMeta = getRoleText(customer?.user?.role, customer?.user?.deferredPaymentEligible);
  const location = picuplocation !== undefined ? picuplocation : pickupLocation;
  const editPath =
    dataVersion === "v2" || dataVersion === "v3"
      ? `/admin/bookinglist/edit/v2/${_id}`
      : `/admin/bookinglist/edit/${_id}`;

  return (
    <tr>
      <td className={cellClass}>{count + 1}</td>
      <td className={cellClass}>{customer?.name}</td>
      <td className={cellClass}>
        <div className="tw:flex tw:flex-col">
          <span className="tw:!text-[15px] tw:!text-[#282828] tw:leading-none tw:mb-1">{roleMeta.role}</span>
          <span className="tw:!text-[13px] tw:!text-[#8D8D8D] tw:leading-none">{roleMeta.detail}</span>
        </div>
      </td>
      <td className={cellClass}>
        <AdminBadge tone={BOOKING_STATUS_TONES[bookingStatus] || "neutral"}>{humanize(bookingStatus)}</AdminBadge>
      </td>
      <td className={cellClass}>{getBookingTypeLabel(bookingType, isAirportTransfer)}</td>
      <td className={cellClass}>
        <AdminBadge tone={PAYMENT_STATUS_TONES[paymentStatus] || "neutral"}>{humanize(paymentStatus)}</AdminBadge>
      </td>
      <td className={`${cellClass} tw:whitespace-nowrap`}>
        <DateTimeCell value={date} />
      </td>
      <td className={`${cellClass} tw:whitespace-nowrap`}>
        <DateTimeCell value={pickupDateTime} />
      </td>
      <td className={cellClass}>
        <span className="tw:block tw:max-w-[260px] tw:truncate">{location?.label}</span>
      </td>
      <td className={cellClass}>{referral !== undefined ? referral?.name : "-"}</td>
      <td className={stickyCellClass}>
        <AdminRowActions>
          <ViewLink to={editPath} label="View detail" />
        </AdminRowActions>
      </td>
    </tr>
  );
};

export default BookingItem;
